import { number, object, string } from 'zod';
export const subjectTokenResponseGuard = object({
    subjectToken: string(),
    expiresIn: number(),
});
